module.exports = __webpack_public_path__ + "img/galery25.3da2251e.jpg";